import View from 'ln/view/View';
import Node from 'ln/node/Node';
import Model from 'ln/model/Model';
import ListRenderer from 'ln/list/ListRenderer';
import { ILink } from 'ln/list/ListRenderer';
import SlideDetailView from './SlideDetailView';
import { ISlide } from './SlideDetailView';
import UserSequenceModel from '../models/UserSequenceModel';
import UserCourseModel from '../../course/models/UserCourseModel';
import CourseElementModel from '../../course/models/CourseElementModel';
import SlideSequence from './SlideSequence';
import setup from 'ln/setup/setup';
import { scanner } from 'ln/view/Scanner';
import SequenceScrollMonitor from './SequenceScrollMonitor';
import CustomUserSequenceModel from '../models/CustomUserSequenceModel';
import SlrgSequenceModel from '../models/SlrgUserSequenceModel';
import CustomSlrgUserSequenceModel from '../models/CustomSlrgUserSequenceModel';
import List from 'ln/list/List';

export interface ISequence extends CourseElementModel{
	slides:Array<ISlide>;
	template:string
}

class SlideView extends View {
	
	public courseData:UserCourseModel;
	public logo:string;
	public previewList:ListRenderer<ISequence>;
	public detail:SlideDetailView;
	private slidePreviewBtn:Node;
	private slideCloseBtn:Node;
	
	constructor(){
		super();
		this.courseData = setup.data( 'course' );
		this.detail = new SlideDetailView();
		this.defaultTemplate = 'krw.slideshow';

		// listen on changes for injecting page number
		this.courseData.sequences.added.add( this.injectPageNumberToSlides, this );
		this.courseData.sequences.removed.add( this.injectPageNumberToSlides, this );
		this.injectPageNumberToSlides();
	}
	
	/**
	 * @overwrite
	 */
	public init(){
		
		var overview = this.node.js( 'slide-overview' );
	
		this.previewList = new ListRenderer<ISequence>( overview );
		
		// render all sequences
		this.previewList.ioc.add( 'default', function( model:ISequence ){
			var sequence = new SlideSequence( model, this.courseData.version, this.courseData.date ).render() as SlideSequence;
			sequence.selected.add( this.updateDetailView, this );
			return { node: sequence.node };
		}.bind( this ));

		this.slidePreviewBtn = this.node.js( 'preview-button' );
		this.slideCloseBtn = this.node.js( 'close-button' );
		
		this.slidePreviewBtn.click.add( this.togglePreview, this );
		this.slideCloseBtn.click.add( this.closeSlideView, this );


		this.previewList.source = this.courseData.sequences as List<ISequence>;

		// listen to the sequence scroll monitor
		var sequencescrollmonitor = scanner.first( 'sequence-scroll-monitor' ) as SequenceScrollMonitor;
		sequencescrollmonitor.change.add( this.showSequence, this );
		
	}
	
	private updateDetailView( slide:ISlide ){
		this.detail.setSlide( slide );
		this.detail.render();
		
		// empty the detailview and append new detail
		this.node.one( '.slide-detailview' ).empty();
		this.node.one( '.slide-detailview' ).append( this.detail.node );

		this.showDetailView();
	}

	private togglePreview(){
		this.node.toggleClass( '-overview' );
		this.node.toggleClass( '-detail', false );
	}

	private showDetailView(){
		this.node.addClass( '-detail' );
		this.node.removeClass( '-overview' );

		if( !document.body.classList.contains( 'nooverflow' ) ) this.toggleBodyScrollbar();
	}

	private closeSlideView(){
		this.node.removeClass( '-detail' );
		this.node.removeClass( '-overview' );

		this.toggleBodyScrollbar();
	}

	private toggleBodyScrollbar(){
		setTimeout( function() { document.body.classList.toggle( 'nooverflow' ) }, 750 );
	}

	private showSequence( visible: ILink<Model>[] ){
		if( visible.length > 0 ){
			
			var topsequence = visible[0].item as ISequence;

			var currentSequence = this.previewList.linkOf( topsequence );

			if( !currentSequence ) return;
			
			var sequenceTop = currentSequence.node.native.offsetTop;
			var overviewTop = this.node.js( 'slide-overview' ).native.offsetTop;
			var diff = sequenceTop - overviewTop;
	
			this.node.js( 'slide-overview' ).native.scrollTop = diff;

		}
	}
	
	private injectPageNumberToSlides(){
		var pagenumber = 1;
		this.courseData.sequences.all().forEach( ( sequence:ISequence ) => {
			if( ( sequence instanceof UserSequenceModel || sequence instanceof CustomUserSequenceModel || sequence instanceof SlrgSequenceModel || sequence instanceof CustomSlrgUserSequenceModel ) && sequence.slides ){
				sequence.slides.forEach( ( slide: ISlide ) => {
					slide.pagenumber = pagenumber.toString();
					pagenumber++;
				});
			}
		});
	}
}

export default SlideView;

scanner.ioc.add( 'slideshow', function( node ){
	return new SlideView().render( node );
});